<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Ventes vendeurs",
          icon: "bi bi-bag-check-fill",
          route: "seller-sales-index",
        },
        {
          label: "Nouvelle vente",
          icon: "bi bi-cart-plus-fill",
          route: "seller-sales-create",
        },
        {
          label: "Ajouter articles",
          icon: "bi bi-plus-square-fill",
          route: "seller-sales-items-create",
        },
      ],
    };
  },
};
</script>
